import type { DesignModels } from '@cadstrom/sigma-engine-shared';

/**
 * Parses a directive bounding-box attribute of the form
 * `"minx,miny,maxx,maxy"` (model coordinates).
 *
 * @param value - The raw attribute value.
 * @returns The bounding box, or undefined when absent or malformed.
 */
export function parseBoundingBoxAttribute(value: string | undefined): DesignModels.ModelBoundingBox | undefined {
	if (value === undefined || value === '') {
		return undefined;
	}
	const parts = value.split(',').map((part) => Number(part.trim()));
	const [minx, miny, maxx, maxy] = parts;
	if (
		parts.length !== 4 ||
		minx === undefined ||
		miny === undefined ||
		maxx === undefined ||
		maxy === undefined ||
		parts.some((part) => !Number.isFinite(part))
	) {
		return undefined;
	}
	if (minx >= maxx || miny >= maxy) {
		return undefined;
	}
	return { minx, miny, maxx, maxy };
}
